import Model from "./Model";

export default class ZohoDevice extends Model {

    static getByCompanyId = async (company_id) => {
        const variables = { company_id: company_id };
        const res = await this.runQuery(GetZohoDevicesByCompany, variables);
        return res.data.zohoDevicesByCompany;
    }
}

const GetZohoDevicesByCompany = `
query GetZohoDevicesByCompany($company_id: Int!) {
    zohoDevicesByCompany(company_id: $company_id) {
        id
        serial_number
        device_owner
        status
        type
        account_id
        account
    }
}`;
